<template>
<div>
    <div class="d-flex align-items-center justify-content-between" >
        <a :href="routeBack" style="color:#111827; border-color:#848486" class="btn btn-secondary" >
            <i class="fe fe-chevron-left mr-2" style="color:#111827;"></i>
            {{ trans['Kembali'] }}
        </a>
        <div v-if="false">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="isMultiLanguage">
                <span class="form-check-label">Dwibahasa</span>
            </div>
        </div>
    </div>

    <h4 class="my-5" style="color:#111827">{{ trans['Maklumat Projek'] }}</h4>
    <div class="card mt-4">
        <div class="card-body">
            <div class="row">
                <div v-if="singleColumn" class="col-12">
                    <span v-if="errors && errors['message']" class="text-danger text-sm">Error : Fail to {{ mode }} the campaign</span>
                </div>
                <div v-else class="col-2">
                    <h4>Campaign Details</h4>
                    <p class="text-muted">Please fill in form for both languages Malay (MS) and English (EN) in order to add new campaign</p>
                </div>

                <div v-if="singleColumn" class="col-12">
                    <div :class="`form-group ${initCampaign ? 'mb-1' : ''}`">
                        <div class="form-label" style="color:#111827;">{{ trans['Nama'] }} <span class="text-red">*</span></div>
                        <div v-if="mode == 'edit' && publishStatus == 'published' && currentRoleUser == 'institution'">
                            <input type="text" class="form-control" style="color: #111827;" name="name[ms]" id="name_ms" placeholder="Project Name" v-model="campaign.name['ms']" required disabled>
                        </div>
                        <div v-else>
                            <input type="text" class="form-control" style="color: #111827;" name="name[ms]" id="name_ms" placeholder="Project Name" v-model="campaign.name['ms']" required>
                        </div>
                        <span v-if="errors && errors['name.ms'] && errors['name.ms'][0]" class="text-danger text-sm">{{ errors['name.ms'][0] }}</span>
                    </div>

                    <span v-if="initCampaign" style="color:#848486;">URL: <a target="_blank" class="btn btn-link pl-0 pb-2" :href="`/ms/kempen/${campaign.slug.ms}`">{{ `${appUrl}/ms/kempen/${campaign.slug['ms']}` }} <i class="fa fa-external-link"></i></a>
                        <small style="color:#848486;">This campaign link can only be used after campaign approval.</small>
                    </span>

                    <div class="form-group">
                        <div class="form-label" style="color:#111827;">{{ trans['Penerangan Projek'] }} <span class="text-red">*</span></div>
                        <quill-editor v-model="campaign.description['ms']"
                        style="color:#111827;"
                        placeholder="enter"
                            class="mb-3"
                            id="rich-text"
                            rows="20"
                            :options="editorOption"
                            ref="myQuillEditor"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)">
                        </quill-editor>
                        <div class="custom-file d-none">
                            <input ref="image" @change="imageUpload($event)" type="file" class="custom-file-input" id="imageUpload" aria-describedby="imageUploadAddon">
                            <label class="custom-file-label" for="imageUpload">Choose file</label>
                        </div>
                        <span v-if="errors && errors['description.ms'] && errors['description.ms'][0]" class="text-danger text-sm">{{ errors['description.ms'][0] }}</span>
                    </div>

                    <div class="form-group mb-0" style="color:#111827;">
                        <div class="form-label">{{ trans['Poster Projek'] }}
                            <span class="text-red">*</span>
                            <span v-if="!singleColumn" class="text-secondary">(Prefered Image Size and Format: 960x512, png, jpg, jpeg)</span>
                            <span v-if="errors && errors['message']" class="text-danger text-sm">Error : {{ errors['message'] }}</span>
                        </div>
                        <div class="container w-50 mx-0 p-4 border rounded">
                            <div class="row">
                                <div class="col-md-12">
                                    <!-- image preview -->
                                    <div class="d-flex justify-content-center align-items-center w-75">
                                        <img v-if="previewImageUrl" :src="previewImageUrl" class="mb-2 rounded"/>
                                    </div>

                                    <div class="d-block align-items-center mb-2">
                                        <div class="custom-file" style="width:70%">
                                            <input id="image_ms" class="custom-file-input" type="file" name="image_ms" ref="image_ms" @change="handleFileUpload('ms')">
                                            <label class="custom-file-label" for="image_ms" style="color:#111827;">Choose file</label>
                                        </div>
                                        <p class="mb-0 ml-2">{{ images['ms'] ? images['ms'].name : '' }}</p>
                                    </div>
                                    <div v-if="mode == 'edit' && getCampaignImageUrl()">
                                        <img :src="getCampaignImageUrl()" class="img-thumbnail mb-2" style="height: 150px; width: auto;">
                                    </div>
                                    <div v-if="campaign.imageUrls.images && campaign.imageUrls['images'] && !campaign.imageUrls['images-ms']">
                                        <img :src="campaign.imageUrls.images" class="img-thumbnail mb-2" style="height: 150px; width: auto;">
                                        <p class="text-danger">
                                            Default poster is already available. Translation poster is required
                                        </p>
                                    </div>

                                    <div class="p-2" style="color:#111827;">
                                        <p class="mb-1">PNG, JPEG, JPG: 10MB file limit</p>
                                        <p class="mb-1">At least 800x800 pixels</p>
                                        <p class="mb-1">1:1 aspect ratio</p>
                                    </div>
                                </div>
                            </div>
                        </div>   <!-- end poster container -->

                        <div class="pt-4" style="color: #111827;">
                            <b style="font-size:14px;">Pro Tip:</b>
                            <ul>
                                <li class="mb-1">Less word image is encouraged.</li>
                                <li class="mb-1">Keep it simple and word in the center.</li>
                                <li class="mb-1">Please ensure the image is emotionally engaging.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- MS -->
                <div v-else class="col-5">
                    <div id="campaign-language-button-ms" :class="`d-flex justify-content-start position-relative mb-3 border-0 campaign-language-button ${getContentValidity('ms') ? 'content-valid' : ''}`">MS</div>
                    <div :class="`form-group ${initCampaign ? 'mb-1' : ''}`">
                        <div class="form-label">Name <span class="text-red">*</span></div>
                        <input type="text" class="form-control" name="name[ms]" id="name_ms" placeholder="Kempen Bantuan Anak Yatim" v-model="campaign.name['ms']" required>
                        <span v-if="errors && errors['name.ms'] && errors['name.ms'][0]" class="text-danger text-sm">{{ errors['name.ms'][0] }}</span>
                    </div>

                    <span v-if="initCampaign" class="text-muted">URL: <a target="_blank" class="btn btn-link pl-0 pb-2" :href="`/ms/kempen/${campaign.slug.ms}`">{{ `${appUrl}/ms/kempen/${campaign.slug['ms']}` }} <i class="fa fa-external-link"></i></a></span>

                    <div class="form-group">
                        <div class="form-label">Description <span class="text-red">*</span></div>
                        <quill-editor v-model="form.body"
                            class="mb-3"
                            id="rich-text"
                            rows="20"
                            :options="editorOption"
                            ref="myQuillEditor"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)">
                        </quill-editor>
                        <div class="custom-file d-none">
                            <input ref="imageMs" @change="imageUpload($event)" type="file" class="custom-file-input" id="imageUploadMs" aria-describedby="imageUploadAddon">
                            <label class="custom-file-label" for="imageUploadMs">Choose file</label>
                        </div>
                        <span v-if="errors && errors['description.ms'] && errors['description.ms'][0]" class="text-danger text-sm">{{ errors['description.ms'][0] }}</span>
                    </div>

                    <div class="form-group">
                        <div class="form-label">Campaign Poster
                            <span class="text-red">*</span>
                            <span class="text-secondary">(Prefered Image Size: 960x512)</span>
                        </div>
                        <div class="d-block align-items-center mb-2">
                            <div class="custom-file" style="width:70%">
                                <input id="image_ms" class="custom-file-input" type="file" name="image_ms" ref="image_ms" @change="handleFileUpload('ms')">
                                <label class="custom-file-label" for="image_ms">Choose file</label>
                            </div>
                            <p class="mb-0 ml-2">{{ images['ms'] ? images['ms'].name : '' }}</p>
                        </div>
                        <div v-if="mode == 'edit' && getCampaignImageUrl()">
                            <img :src="getCampaignImageUrl()" class="img-thumbnail mb-2" style="height: 150px; width: auto;">
                        </div>
                        <div v-if="campaign.imageUrls.images && campaign.imageUrls['images'] && !campaign.imageUrls['images-ms']">
                            <img :src="campaign.imageUrls.images" class="img-thumbnail mb-2" style="height: 150px; width: auto;">
                            <p class="text-danger">
                                Default poster is already available. Translation poster is required
                            </p>
                        </div>
                    </div>
                </div>
                <!-- EN -->
                <div v-if="isMultiLanguage" class="col-5">
                    <div id="campaign-language-button-en" :class="`d-flex justify-content-start position-relative mb-3 border-0 campaign-language-button ${getContentValidity('en') ? 'content-valid' : ''}`">EN</div>

                    <div :class="`form-group ${initCampaign ? 'mb-1' : ''}`">
                        <div class="form-label">Name <span class="text-red">*</span></div>
                        <input type="text" class="form-control" name="name[en]" id="name_en" placeholder="Kempen Bantuan Anak Yatim" v-model="campaign.name['en']" required>
                        <span v-if="errors && errors['name.en'] && errors['name.en'][0]" class="text-danger text-sm">{{ errors['name.en'][0] }}</span>
                    </div>

                    <span v-if="initCampaign" class="text-muted">URL: <a target="_blank" class="btn btn-link pl-0 pb-2" :href="`/en/kempen/${campaign.slug.en}`">{{ `${appUrl}/en/kempen/${campaign.slug['en']}` }} <i class="fa fa-external-link"></i></a></span>

                    <div class="form-group">
                        <div class="form-label">Description <span class="text-red">*</span></div>
                        <quill-editor v-model="form.body"
                            class="mb-3"
                            id="rich-text"
                            rows="20"
                            :options="editorOption"
                            ref="myQuillEditor"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)">
                        </quill-editor>
                        <div class="custom-file d-none">
                            <input ref="imageEn" @change="imageUpload($event)" type="file" class="custom-file-input" id="imageUploadEn" aria-describedby="imageUploadAddon">
                            <label class="custom-file-label" for="imageUploadEn">Choose file</label>
                        </div>
                        <span v-if="errors && errors['description.en'] && errors['description.en'][0]" class="text-danger text-sm">{{ errors['description.en'][0] }}</span>
                    </div>

                    <div class="form-group">
                        <div class="form-label">Campaign Poster
                            <span class="text-red">*</span>
                            <span class="text-secondary">(Prefered Image Size: 960x512)</span>
                        </div>
                        <div class="d-block align-item-center mb-2">
                            <div class="custom-file" style="width:70%">
                                <input id="image_en" class="custom-file-input" type="file" name="image_en" ref="image_en" @change="handleFileUpload('en')">
                                <label class="custom-file-label" for="image_en">Choose file</label>
                            </div>
                            <p class="mb-0 ml-2">{{ images['en'] ? images['en'].name : '' }}</p>
                        </div>
                        <div v-if="mode == 'edit' && getCampaignImageUrl()">
                            <img :src="getCampaignImageUrl()" class="img-thumbnail mb-2" style="height: 150px; width: auto;">
                        </div>
                        <div v-if="campaign.imageUrls.images && campaign.imageUrls['images'] && !campaign.imageUrls['images-en']">
                            <img :src="campaign.imageUrls.images" class="img-thumbnail mb-2" style="height: 150px; width: auto;">
                            <p class="text-danger">
                                Default poster is already available. Translation poster is required
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-body">
            <div class="row" style="color: #111827;">
                <div class="col-12 mb-4">
                    <h4 style="margin:0px; color:#111827; font-size:14px; font-weight:600 !important;">{{ trans['Penerangan Pakej'] }}</h4>
                </div>
                <div class="col-12" >
                    <package-form
                        :init-packages="initCampaign ? initCampaign.packages : campaign.packages"
                        @packagesContentChange="handlePackagesContentChange($event)"
                        :errors="errors"
                        :is-multi-language="isMultiLanguage"
                        :trans="trans"
                    >
                    </package-form>
                </div>
            </div>
        </div>

        <div class="card-body" style="color: #111827;">
            <div class="row">
                <div class="col-12">
                    <div :class="`form-group ${initCampaign ? 'mb-4 col-3 pl-0' : 'col-3 pl-0'}`" >
                        <div class="form-label">{{ trans['Projek Kategori'] }} <span class="text-red">*</span></div>
                        <select class="custom-select" style="color:#111827;" name="category_id" id="category_id" v-model="campaign.category_id" required>
                            <option value="0" disabled>Select Category</option>
                            <option value="1" v-for="category in categories" :value="category.id">
                                {{ category.name[lang] }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group col-3 pl-0" v-if="currentRoleUser == 'admin'">
                        <div class="form-label">Status</div>
                        <select class="custom-select" style="color: #111827" name="publish_status" id="publish_status" v-model="publishStatus">
                            <option value="" disabled>Select Status</option>
                            <option value="draft">Draft</option>
                            <option value="published">Published</option>
                        </select>
                    </div>
                    <div class="form-group col-4 pl-0" v-else>
                        <input class="form-control" type="hidden" name="publish_status" id="publish_status" v-model="publishStatus">
                        <input class="form-control" type="hidden" name="institution_id" id="institution_id" v-model="campaign.institution_id">
                    </div>

                    <div class="row">
                        <div class=" col-3 form-group pr-2">
                            <div class="form-label">{{ trans['Tarikh Mula'] }}</div>
                            <input class="form-control" type="date" placeholder="Start Date" name="start_at" v-model="campaign.start_at"></input>
                        </div>

                        <div class="col-3 form-group">
                            <div class="form-label">{{ trans['Tarikh Tamat'] }}</div>
                            <input class="form-control" type="date" name="end_at" v-model="campaign.end_at"></input>
                        </div>
                    </div>

                    <div class="form-group col-3 pl-0">
                        <div class="form-label" >{{ trans['Sasaran Kutipan'] }} (RM) <span class="text-red">*</span></div>
                        <input type="number" placeholder="Amount (RM)" class="form-control" name="amount_targeted" id="amount_targeted" required v-model="campaign.amount_targeted">
                    </div>

                    <div class="form-group col-4 pl-0" v-if="isNotMultiTenant">
                        <div class="form-label">Billplz Collection ID <span class="text-red">*</span></div>
                        <input type="text" class="form-control" name="collection_id" id="collection_id" required v-model="campaign.collection_id">
                    </div>

                    <!-- <div class="form-group">
                        <div class="form-label">Settings</div>
                        <div class="custom-controls-stacked">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" name="is_name_required" v-model="campaign.isNameRequired">
                                <div class="custom-control-label">{{ trans['Kempen ini memerlukan penama penyumbang (Korban)'] }}</div>
                            </label>
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" name="is_anonymous_disallowed" value="is_anonymous_disallowed" v-model="campaign.isAnonymousDisallowed" :checked="campaign.isAnonymousDisallowed">
                                <div class="custom-control-label">{{ trans['Kempen ini memerlukan detail penyumbang (Anonymous tidak dibenarkan)'] }}</div>
                            </label>
                        </div>

                    </div> -->

                    <div class="d-flex justify-content-start">
                        <button v-if="mode == 'add'" type="button" id="add-campaign" @click="submit()" style="color:#111827; padding: 8px 16px; background-color:#4CAF50; border:#4CAF50; opacity:1;" class="btn btn-primary" :disabled="!getFormValidity() || isUpdating">{{ trans['Tambah Projek'] }}</button>
                        <button v-else type="button" id="update-campaign" @click="submit()" class="btn" style="color:#111827; padding: 8px 16px; background-color:#4CAF50; border:#4CAF50; opacity:1;" :disabled="!getFormValidity() || isUpdating">{{ trans['simpan'] }}</button>
                        <moon-loader class="ml-2" :loading="isUpdating" id="spinner" :color="'#26A65B'" :size="'36px'"></moon-loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>
   .campaign-language-button.content-valid::after {
        background-color: #1d9f3c;
    }
    .campaign-language-button:not(.content-valid) {
        color: #cd201f !important;
    }
    .campaign-language-button {
        padding-left: 1rem !important;
    }
    .campaign-language-button::after {
        content: "";
        position: absolute;
        border-radius: 50%;
        height: 7px;
        width: 7px;
        background-color: #cd201f;
        left: 1px;
        top: 55%;
        margin-top: -4px;
    }
    .campaign-toast {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !default;
        color: white;
        background-color: #5eba00 !important;
    }
</style>

<script>
    import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min';

    // Import Quill required dependencies
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import { quillEditor, Quill } from 'vue-quill-editor'
    import ImageResize from 'quill-image-resize';

    // Register ImageResize module
    Quill.register('modules/imageResize', ImageResize);

    // Set toolbar options
    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],

        [{'header': 1}, {'header': 2}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'script': 'sub'}, {'script': 'super'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{'direction': 'rtl'}],

        [{'size': ['small', false, 'large', 'huge']}],
        [{'header': [1, 2, 3, 4, 5, 6, false]}],

        [{'color': []}, {'background': []}],
        [{'font': []}],
        [{'align': []}],
        ['link', 'image', 'video'],
        ['clean'],
    ];

    export default {
        data() {
            return {
                lang: this.initLang,
                campaign: {
                    name: {
                        'en': '',
                        'ms': ''
                    },
                    slug: {
                        'en': '',
                        'ms': ''
                    },
                    description: {
                        'en': '',
                        'ms': ''
                    },
                    description_images: [],
                    imageUrls: [],
                    start_at: '',
                    end_at: '',
                    amount_targeted: '',
                    collection_id: '',
                    packages: [
                        {
                            name: {
                                'en': '',
                                'ms': ''
                            },
                            amount: '',
                            archived_at: '',
                            is_open: 0
                        }
                    ],
                    category_id: 0,
                    institution_id: this.institution
                },
                publishStatus: this.initCampaign && this.initCampaign.published_at ? 'published' : this.initCampaign ? 'draft' : '',
                images: {
                    ms: '',
                    en: ''
                },
                errors: {},
                testsatu: '',
                isUpdating: false,
                isMultiLanguage: this.isNotMultiTenant,
                previewImageUrl: null,
                // quill editor
                form: {
                    body: ''
                },
                editorOption: {
                    modules: {
                        toolbar: {
                            container: toolbarOptions,
                            handlers: {
                                'image': function (value) {
                                    if (value) {
                                        document.querySelector('#imageUpload').click();
                                    } else {
                                        this.quill.format('image', false);
                                    }
                                }
                            },
                        },
                        history: {
                            delay: 1000,
                            maxStack: 50,
                            userOnly: false
                        },
                        imageResize: {
                            displayStyles: {
                                backgroundColor: 'black',
                                border: 'none',
                                color: 'white'
                            },
                            modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
                        }
                    }
                },
                // tinymce-vue
                editorInit: {
                    height: 300,
                    plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table contextmenu paste imagetools"
                    ],
                    media_live_embeds: true,
                    entity_encoding : 'raw',
                    automatic_uploads: true,
                    toolbar: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image code",
                    file_picker_types: 'image'
                }
            };
        },
        components: {
            MoonLoader,
            quillEditor
        },
        props: {
            routeBack: {},
            appUrl: {},
            route: {},
            csrf: {},
            trans: {},
            initLang: {},
            mode: {},
            initCampaign: {
                default: function() {
                    return null;
                },
            },
            currentRoleUser: {},
            categories: {},
            institution: {},
            isNotMultiTenant: {
                default: true
            },
            singleColumn: {
                default: false
            }
        },
        computed: {
        },
        methods: {
            onEditorBlur(editor) {
                // console.log('editor blur!', editor)
            },
            onEditorFocus(editor) {
                // console.log('editor focus!', editor)
            },
            onEditorReady(editor) {
                // console.log('editor ready!', editor)
            },
            imageUpload(e) {
                if (e.target.files.length !== 0) {

                    let quill = this.editor;
                    let reader = new FileReader();
                    reader.readAsDataURL(e.target.files[0]);
                    let self = this;
                    reader.onloadend = function() {
                        let base64data = reader.result;
                        self.campaign.description_images.push(base64data);

                        // Get cursor location
                        let length = quill.getSelection().index;

                        // Insert image at cursor location
                        quill.insertEmbed(length, 'image', base64data);

                        // Set cursor to the end
                        quill.setSelection(length + 1);
                    }
                }
            },
            handleFileUpload(lang) {
                this.images[lang] = this.$refs[`image_${lang}`].files[0];

                //create image preview
                const file = document.getElementById('image_ms').files[0];
                this.previewImageUrl = URL.createObjectURL(file);
                URL.revokeObjectURL(file);
            },
            submit() {
                this.isUpdating = true;
                let data = new FormData();

                if (this.mode == 'edit') {
                    data.append('_method', 'PUT');
                }

                data.append('publish_status', this.publishStatus);

                data.append('is_multi_language', this.isMultiLanguage);

                Object.keys(this.campaign).forEach(key => {
                    let input =
                        ['name', 'slug', 'description', 'preferences', 'packages', 'media', 'description_images'].includes(key)
                            ? JSON.stringify(this.campaign[key])
                            : this.campaign[key];

                    data.append(key, input);

                    if (key == 'start_at' && this.campaign.start_at == '')
                        data.append(key, []);
                    if (key == 'end_at' && this.campaign.end_at == '')
                        data.append(key, []);
                    if (key == 'institution_id' && this.campaign.institution_id == null)
                        data.append(key, []);
                });

                if (this.images['ms']) {
                    data.append('image_ms', this.images['ms']);
                }

                if (this.images['en']) {
                    data.append('image_en', this.images['en']);
                }

                // for (var pair of data.entries()) {
                //     console.log(pair[0]+ ', ' + pair[1]);
                // }

                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                axios.post(
                    this.route,
                    data
                ).then((response) => {
                    this.$toasted.show(`Campaign ${this.mode == 'add' ? 'added' : 'updated'}`, {
                        theme: "toasted-primary",
                        position: "bottom-right",
                        duration : 20000,
                        icon: {name: 'check'},
                        className: ['campaign-toast', 'font-weight-bold']
                    });

                    this.resetData(response.data);

                    if (this.mode == 'add') {
                        window.location.href = this.routeBack;
                    } else {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    }
                    this.isUpdating = false;
                }).catch((error) => {
                    window.scrollTo(0,0);
                    this.errors = _.get(error, 'response.data');
                    this.isUpdating = false;
                });
            },
            handlePackagesContentChange(data) {
                Vue.set(this.campaign, 'packages', data.packages);
            },
            getCampaignImageUrl() {
                return this.campaign.imageUrls[`images-${this.lang}`];
            },
            resetData(campaign) {
                campaign.start_at = campaign.start_at != 'null' ? moment(campaign.start_at).tz("Asia/Kuala_Lumpur").format('YYYY-MM-DD') : null;
                campaign.end_at = campaign.end_at != 'null' ? moment(campaign.end_at).tz("Asia/Kuala_Lumpur").format('YYYY-MM-DD') : null;
                this.campaign = campaign;
                this.publishStatus = campaign.published_at ? 'published' : 'draft';
                this.images = {
                    ms: '',
                    en: ''
                };
                this.campaign.description_images = [];
                this.errors = {};
            },
            getContentValidity(lang) {
                let invalidPackageExist = this.campaign.packages.length && _.find(this.campaign.packages, p => {
                    return !p.name[lang] || ((!p.amount || p.amount < 3) && !p.is_open);
                }) !== undefined;

                let valid = this.campaign.name[lang] &&
                        this.campaign.description[lang] &&
                        (this.campaign.imageUrls[`images-${lang}`] || this.images[lang]);

                return valid && ! invalidPackageExist;
            },
            getFormValidity() {
                return this.getContentValidity('ms') && (! this.isMultiLanguage || this.getContentValidity('en')) && this.campaign.amount_targeted;
            }
        },
        computed: {
            editor(){
                return this.$refs.myQuillEditor.quill
            }
        },
        mounted() {
            if (this.initCampaign) {
                this.campaign = this.initCampaign;
                if (this.initCampaign.start_at) {
                    this.campaign.start_at = moment(this.initCampaign.start_at).tz("Asia/Kuala_Lumpur").format('YYYY-MM-DD');
                }
                if (this.initCampaign.end_at) {
                    this.campaign.end_at = moment(this.initCampaign.end_at).tz("Asia/Kuala_Lumpur").format('YYYY-MM-DD');
                }
                this.campaign.description_images = [];
            }
        }
    }
</script>